import { render, staticRenderFns } from "./CalculatePriceBlockOrientation.vue?vue&type=template&id=3082abb6&scoped=true&"
import script from "./CalculatePriceBlockOrientation.vue?vue&type=script&lang=js&"
export * from "./CalculatePriceBlockOrientation.vue?vue&type=script&lang=js&"
import style0 from "./CalculatePriceBlockOrientation.vue?vue&type=style&index=0&id=3082abb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3082abb6",
  null
  
)

export default component.exports